import { useState } from 'react';
import './App.css';

function Eagler0() {
    return (
        <div className="App">
            <h1><div className="nametag">@skulldagrait</div> needs to check this out and add a widget.</h1>
        </div >
    );
}

export default Eagler0;